import React from 'react'
import { Band, BandActions, BandSub, BandTitle, OrangeButton, OutlineButton } from './CtaBand.styles'

interface CtaBandProps {
	/** Marketing / app-store link both CTAs open. */
	getOrbitUrl: string
}

/**
 * The marketing CTA band below the bento (public mode only): an indigo rounded
 * band with the headline, subcopy, an outlined "See how it works" link and the
 * solid-orange "Get Orbit free" CTA.
 */
const CtaBand: React.FC<CtaBandProps> = ({ getOrbitUrl }) => (
	<Band>
		<div>
			<BandTitle>Get the trip out of the group chat.</BandTitle>
			<BandSub>
				This page is a real trip planned with Orbit — the itinerary, the ideas, and the money in one place.
			</BandSub>
		</div>
		<BandActions>
			<OutlineButton href={getOrbitUrl} target="_blank" rel="noreferrer">
				See how it works
			</OutlineButton>
			<OrangeButton href={getOrbitUrl} target="_blank" rel="noreferrer">
				Get Orbit free
			</OrangeButton>
		</BandActions>
	</Band>
)

export default CtaBand
